import React from 'react';

import WorkforceContractsIndex from '../../workforce_contracts/WorkforceContractsIndex';

const ProcurementContractManagementWorkforceContractsTab = () => {
    return <WorkforceContractsIndex />;
};

export default ProcurementContractManagementWorkforceContractsTab;
